import React, { useEffect } from 'react';
import { CircleHelp, Search, Table2, X } from 'lucide-react';
import './LeadsHubHelpModal.css';

export interface LeadsHubHelpModalProps {
  onClose: () => void;
  onTakeTour?: () => void;
}

const LeadsHubHelpModal: React.FC<LeadsHubHelpModalProps> = ({ onClose, onTakeTour }) => {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  return (
    <div className="lh-help-overlay" role="presentation" onClick={onClose}>
      <div
        className="lh-help-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="lh-help-title"
        onClick={e => e.stopPropagation()}
      >
        <header className="lh-help-header">
          <div className="lh-help-header-main">
            <div className="lh-help-icon" aria-hidden>
              <CircleHelp size={18} />
            </div>
            <div>
              <h2 id="lh-help-title" className="lh-help-title">
                Leads hub guide
              </h2>
              <p className="lh-help-subtitle">Filter, search, and open client workspaces from one list.</p>
            </div>
          </div>
          <button type="button" className="lh-help-close" onClick={onClose} aria-label="Close help">
            <X size={18} />
          </button>
        </header>

        <div className="lh-help-body">
          <section className="lh-help-section">
            <h3>
              <Search size={16} /> Finding leads
            </h3>
            <p>
              Use the sidebar to filter by status, date range, and source. The search bar matches name, email,
              phone, company, and location. Hot Leads shows prospects with strong enrichment scores.
            </p>
          </section>
          <section className="lh-help-section">
            <h3>
              <Table2 size={16} /> Working the list
            </h3>
            <p>
              Click a row to open the client workspace. <strong>Last Updated</strong> reflects comments, documents,
              projects, and logged activity. Select multiple rows to bulk-update status, archive, or delete.
            </p>
          </section>
          <section className="lh-help-section">
            <h3>
              <Search size={16} /> Quick search
            </h3>
            <p>
              Press <strong>Space</strong> anywhere on the leads page (when not typing in a field) to open quick
              search — jump to any lead, contact, or deal instantly.
            </p>
          </section>
          {onTakeTour && (
            <button type="button" className="lh-help-tour-btn" onClick={onTakeTour}>
              Take the walkthrough
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadsHubHelpModal;
